import { motion } from 'framer-motion';

export const ProductHuntWidget = () => {
  return null;
};
